export function DashboardFrame({ children }: { children: React.ReactNode }) {
  return (
    // Cards clip their overflow, which drops their automatic min-height; keep them from
    // collapsing when the page is taller than the scroll area.
    <div className="flex min-h-full min-w-0 flex-1 flex-col gap-4 px-6 pt-6 pb-5 *:shrink-0">
      {children}
    </div>
  );
}
